import{isObject as r}from"@guildeducationinc/type-guards";var n=function(n){return r(n)&&(!("parent"in n)||r(n.parent)&&"current"in n.parent&&(null===n.parent.current||"tagName"in n.parent.current))};export{n as isOverlayable};
//# sourceMappingURL=Overlayable.js.map
